import i18n from '@/locales/i18n';

const status = {
  400: i18n.t('common:serverErrorTips'), //未指定具体错误消息的请求参数输入错误
  400100: i18n.t('common:verificationCodeErrorTips'), //表示验证码不对
  400101: i18n.t('common:emailFormatErrorTips'), //email 应该在 100 个字符以内
  400102: i18n.t('common:emailFormatErrorTips'), //无效的 email 地址
  400104: i18n.t('common:emailRegisteredTips'), //账号已存在
  400200: i18n.t('common:passwordFormatErrorTips'), //密码无效，必须包含数字和字母
  400201: i18n.t('loginAndSignUp:loginAccountOrPasswordErrorTips'), //密码不正确
  400202: i18n.t('personalCenterSetting:changePasswordComfirmDiffErrorTips'), //确认密码不正确
  400203: i18n.t('common:passwordFormatErrorTips'), //密码必须在8-20个字符
  400204: i18n.t('personalCenterSetting:changePassWordSameErrorTips'), //新密码不能跟旧密码同样
  400205: i18n.t('loginAndSignUp:loginAccountOrPasswordErrorTips'), //账号或者密码不正确
  400206: i18n.t('personalCenterSetting:changePasswordCurrentErrorTips'), //当前密码不正确
  400301: i18n.t('common:verificationCodeErrorTips'), //表示验证码不对
  401: i18n.t('common:authorizationExpiredErrorTips'), //用户未登录，或者登录态已过期，需要重新登录
  // 402: "You are trying to access a paid functionality, please subscribe first", //免费用户尝试使用收费功能时的提醒
  403: i18n.t('common:serverErrorTips'), //用户访问了无权限访问的资源
  404001: i18n.t('loginAndSignUp:loginAccountNotExitErrorTips'), // 账号不存在
  404101: "Couldn't find your files or folders", //文件或文件夹不存在
  429: i18n.t('common:requestFrequentlyErrorTips'), //用户短时间内请求次数太多
  500: i18n.t('common:serverErrorTips'), //表示服务器发生了未知的内部错误
  501: i18n.t('common:serverErrorTips'), //表示不支持此操作
};

export default status;
